// Regional settings for the events calendar. `dateFormat` is NOT a language
// choice: _events-calendar.js parses the selected date back with
// moment(dateText, 'DD.MM.YYYY'), so both locales must emit dd.mm.yy.

var datepickerBehaviour = {
    duration: 0,
    dateFormat: 'dd.mm.yy',
    firstDay: 1,
    isRTL: false,
    showAnim: 'fadeIn',
    showOtherMonths: true,
    showMonthAfterYear: false,
    yearSuffix: '',
    prevText: '',
    nextText: ''
};

$.datepicker.regional['ru'] = $.extend({}, datepickerBehaviour, {
    closeText: 'Закрыть',
    currentText: 'Сегодня',
    monthNames: ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
    monthNamesShort: ['января','февраля','марта','апреля','мая','июня','июля','августа','сентября','октября','ноября','декабря'],
    dayNames: ['воскресенье','понедельник','вторник','среда','четверг','пятница','суббота'],
    dayNamesShort: ['вск','пнд','втр','срд','чтв','птн','сбт'],
    dayNamesMin: ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'],
    weekHeader: 'Не'
});

$.datepicker.regional['en'] = $.extend({}, datepickerBehaviour, {
    closeText: 'Close',
    currentText: 'Today',
    monthNames: ['January','February','March','April','May','June','July','August','September','October','November','December'],
    monthNamesShort: ['January','February','March','April','May','June','July','August','September','October','November','December'],
    dayNames: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
    dayNamesShort: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
    dayNamesMin: ['Su','Mo','Tu','We','Th','Fr','Sa'],
    weekHeader: 'Wk'
});

$.datepicker.setDefaults($.datepicker.regional[document.body.dataset.locale] || $.datepicker.regional['ru']);
